
import Box from '@mui/material/Box';
import { IRapportSpacingControl } from './RapportMallTypes';
import {
  AVENY_REPORT_DEFAULT_SPACING,
  SELECTED_SHADOW,
  getPositionStyle,
} from './RapportMallUtils';
import { RapportKontrollHeader } from './RapportKontrollHeader';
import { RapporteditorTextField } from '../Rapporteditor/RapporteditorTextField';

export interface IProps {
  ctrl: IRapportSpacingControl;
  sx?: any;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onSelect?: (path: number[]) => void;
  onUpdate?: (updatedControl: IRapportSpacingControl) => void;
  controlPath: number[];
  selected?: boolean;
  maxWidth: number;
}

export const RapportSpacing: React.FC<IProps> = props => {
  const { ctrl, sx, onMouseEnter, onMouseLeave, selected, maxWidth } = props;
  const handleSelect = (e?: React.MouseEvent) => {
    if (e) e.stopPropagation();
    if (props.onSelect) {
      props.onSelect(props.controlPath);
    }
  };
  return (
    <Box
      sx={{
        boxShadow: selected ? SELECTED_SHADOW : undefined,
        boxSizing: 'border-box',
        ...getPositionStyle(
          ctrl,
          props.controlPath.length > 1,
          maxWidth,
          AVENY_REPORT_DEFAULT_SPACING
        ),
        ...sx,
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={handleSelect}
      data-control-path={props.controlPath.join('-')}
    />
  );
};

export interface IRapportSpacingEditProps {
  value: IRapportSpacingControl;
  onChange: (ctrl: IRapportSpacingControl) => void;
}

export const RapportSpacingEdit: React.FC<IRapportSpacingEditProps> = props => (
  <Box sx={{ mt: 2 }}>
    <RapportKontrollHeader value={props.value} />
    <RapporteditorTextField
      label="Mellanrum"
      field="Height"
      value={props.value}
      onChange={props.onChange}
      numeric
    />
  </Box>
);
